//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String
    }
  }
};